import { TYPES_SIGNIN } from 'components/TargetedOffers/constants';
import { CALL_ORIGIN_TARGETED_OFFERS } from 'contexts/CruiseSearchContext/constants';
import { getTargetedOffers } from 'lib/graphql/campaigns/campaigns.client';
import { validateErrorResponseTargetedOffers } from './validateErrorResponseTargetedOffers';

export const getTargetedOffersLogin = async ({ input, showTargetedOffersPerksQualifiers, apolloClient, brand, config }) => {
	const { loyaltyID, email, emailEncrypt, originLoyalty, originEmail } = input;
	const queryVariable = { brand, initialLoad: input.origin !== CALL_ORIGIN_TARGETED_OFFERS.FORM };
	const filters = {};
	const [typeEmail, typeLoyalty] = TYPES_SIGNIN;
	let targetedOffersLoaded = true;

	queryVariable['displayQualifier'] = !!showTargetedOffersPerksQualifiers;

	if (email) {
		queryVariable['email'] = email;
		filters['email'] = email;
		filters['TypeSignIn'] = typeEmail;
	}

	if (loyaltyID) {
		queryVariable['loyaltyID'] = loyaltyID;
		filters['loyaltyID'] = loyaltyID;
		filters['TypeSignIn'] = typeLoyalty;
	}

	const { data, errors, networkError } = await getTargetedOffers(apolloClient, queryVariable);

	const dataToValidate = {
		networkError,
		loyaltyID,
		email: emailEncrypt || email,
		isEncrypt: !!emailEncrypt,
		errors,
		originLoyalty,
		originEmail,
		config,
	};

	const { code, isValid, isNetWorkError } = await validateErrorResponseTargetedOffers(dataToValidate);

	if (!isValid) {
		if (originLoyalty === CALL_ORIGIN_TARGETED_OFFERS.COOKIE) {
			targetedOffersLoaded = false;
			filters['loyaltyID'] = '';
		}

		if (originEmail === CALL_ORIGIN_TARGETED_OFFERS.COOKIE) {
			targetedOffersLoaded = false;
			filters['email'] = '';
		}
	}

	return {
		data: {
			targetedOffers: data?.targetedOffers || [],
			targetedOffersLoaded,
			targetedOffersLoading: false,
			errorTargetedOffers: {
				code,
				isNetWorkError,
			},
			targetedOffersQuery: filters,
			targetedOffersLogged: isValid,
			targetedFilters: isValid ? filters : {},
		},
		isValid,
	};
};
